import { createContext } from "react";
export var SidebarContext = /*#__PURE__*/ createContext(null);
